import styled, { css } from 'styled-components';

import { UIRefreshOffers } from 'components/offers/ui-refresh';
import BlockRenderer from 'components/sanity-block-renderer';

import { LoyaltyLoader } from '../loyalty-loader';

export const IncentivesContainer = css`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;

  ${Styles.desktop`
    height: 100vh;
  `}
`;

export const StyledUIRefreshOffers = styled(UIRefreshOffers)`
  height: 100%;
  overflow: auto;
  ${Styles.desktop`
    ${IncentivesContainer}
  `}
`;

export const StyledBlockRenderer = styled(BlockRenderer)`
  margin: 0;
  font-size: 0.8125rem;
`;

export const LoyaltyIncentivesContainer = styled.div`
  ${IncentivesContainer}
  flex-direction: column;
`;

export const StyledLoyaltyLoader = styled(LoyaltyLoader)`
  height: 80vh;
`;
